import styled from '@emotion/styled';

import { DESKTOP } from '@/styles/themes';

export const Wrapper = styled.div`
  display: flex;
  padding: 40px 24px 24px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  border: 1px solid #e4ebf0;
  border-radius: 12px;
  background: #fff;
  width: 100%;

  ${DESKTOP} {
    padding: 48px 32px 32px 32px;
  }
`;
